module.exports = __webpack_public_path__ + "img/02.210be8a8.jpg";